import React from "react";
import { useContent } from "@/context/ContentContext";

/** WhatsApp green for the brand mark; site palette stays dark. */
const WA_GREEN = "#25D366";

function buildWhatsAppHref(rawNumber, message) {
  if (!rawNumber) return null;
  const digits = String(rawNumber).replace(/\D/g, "");
  if (!digits) return null;
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
}

export default function FloatingWhatsApp() {
  const { content } = useContent() || {};
  const f = content?.footer || {};
  const number = f.whatsapp_number || "+917002310482";
  const message = f.whatsapp_message || "Hi Ranjana — I came from your portfolio.";
  const href = buildWhatsAppHref(number, message);
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="floating-whatsapp"
    >
      <span className="floating-whatsapp__pulse" aria-hidden="true" />
      <svg
        viewBox="0 0 32 32"
        width="26"
        height="26"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.21c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.6.13-.18.27-.7.88-.86 1.06-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.6-1.45-.83-1.99-.22-.52-.44-.45-.6-.46l-.51-.01c-.18 0-.47.07-.71.34-.25.27-.94.92-.94 2.25 0 1.32.96 2.6 1.1 2.79.13.18 1.89 2.88 4.58 4.04.64.28 1.14.45 1.53.57.64.2 1.22.17 1.68.1.51-.08 1.6-.65 1.83-1.28.23-.63.23-1.16.16-1.28-.07-.12-.25-.18-.52-.32zM16.02 5C9.94 5 5 9.94 5 16.02c0 1.95.51 3.85 1.48 5.51L5 27l5.61-1.46c1.6.87 3.4 1.34 5.4 1.34h.01c6.07 0 11.02-4.94 11.02-11.02 0-2.94-1.15-5.7-3.23-7.79-2.08-2.08-4.84-3.23-7.79-3.23z"/>
      </svg>
      <span className="floating-whatsapp__label">WhatsApp</span>
    </a>
  );
}
